import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useState } from "react";
import { useRouter } from "next/router";
import { noop } from "@catchoftheday/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CatalogueContext = /*#__PURE__*/createContext({
  updateQueryParams: noop,
  searchResponse: null,
  updateSearchResponse: noop
});
export var CatalogueContextProvider = function CatalogueContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      searchResponse = _useState[0],
      setSearchResponse = _useState[1];

  var router = useRouter();

  var updateQueryParams = function updateQueryParams(params) {
    var newQuery = _objectSpread(_objectSpread({}, router.query), params);

    router.push({
      pathname: router.pathname,
      query: newQuery
    }, undefined, {
      shallow: true
    });
  };

  var updateSearchResponse = function updateSearchResponse(response) {
    setSearchResponse(response);
  };

  return ___EmotionJSX(CatalogueContext.Provider, {
    value: {
      updateQueryParams: updateQueryParams,
      searchResponse: searchResponse,
      updateSearchResponse: updateSearchResponse
    }
  }, children);
};